import {ReportCategoryTypes} from '../../../core/entities/reports/constants';
import type {FilterItem} from './useHandleReports';

export const getReportUrlForPc = (filterItems: FilterItem): string => {
  const types = filterItems.reportType.map((type) => {
    return ReportCategoryTypes.types.find((t) => t.id === type)?.key;
  });
  const departments = filterItems.department;

  const url = `?type=${
    types ? (Array.isArray(types) ? types.join(',') : types) : ''
  }&department=${
    departments
      ? Array.isArray(departments)
        ? departments.join(',')
        : departments
      : ''
  }`;

  return url;
};
